import { Link } from 'react-router-dom';

const allServices = [
  {
    id: 'ppf',
    icon: 'ri-shield-fill',
    title: 'Paint Protection Film (PPF)',
    subtitle: 'Clear Bra / Full Vehicle / Partial',
    description: 'XPEL-certified paint protection film creates an invisible, self-healing barrier over your paint. Rock chips, road debris, scratches, and UV exposure are absorbed and deflected — keeping your paint in showroom condition for years.',
    details: [
      'Computer-cut patterns for your exact vehicle',
      'XPEL ULTIMATE PLUS — the world\'s best self-healing PPF',
      'Full vehicle, front end, or custom coverage packages',
      '10-year manufacturer warranty against yellowing & peeling',
      'Optically clear — completely invisible after installation',
    ],
    image: 'https://public.readdy.ai/ai/img_res/aa81b18a3d523bbe612a05130b308f75.jpg',
    badge: 'XPEL Certified',
    featured: true,
  },
  {
    id: 'ceramic',
    icon: 'ri-sparkling-2-fill',
    title: 'Ceramic Coating',
    subtitle: 'Professional Grade · 9H Hardness',
    description: 'Professional ceramic coating chemically bonds to your paint, creating a semi-permanent hydrophobic shield that repels water, bird droppings, UV rays, and environmental contaminants — while delivering an extraordinary depth of gloss.',
    details: [
      '9H rated surface hardness — harder than factory clear coat',
      'Hydrophobic water-beading effect that lasts years',
      'UV oxidation and fade protection',
      'Dramatically enhanced gloss and color depth',
      'Available in 2-year, 3-year, and 5-year durability tiers',
    ],
    image: 'https://readdy.ai/api/search-image?query=ceramic%20coating%20professional%20application%20luxury%20black%20sports%20car%20water%20beading%20hydrophobic%20effect%20automotive%20studio%20clean%20premium%20dark%20background%20detailing%20specialist&width=700&height=460&seq=svc_full_cer1&orientation=landscape',
    badge: 'Most Popular',
    featured: false,
  },
  {
    id: 'tint',
    icon: 'ri-sun-fill',
    title: 'Window Tint',
    subtitle: 'Heat Rejection · Privacy · UV Block',
    description: 'Premium window film blocks up to 99% of UV rays and significantly reduces cabin heat — protecting your interior, enhancing privacy, and giving your vehicle a sharp, clean aesthetic. All films are CT-legal and carry a lifetime warranty.',
    details: [
      '99% UV ray rejection — protects skin and interior',
      'Significant heat and infrared rejection',
      'CT-legal shades for all window positions',
      'Automotive-grade ceramic film for clarity and durability',
      'Lifetime warranty on all films and installation',
    ],
    image: 'https://readdy.ai/api/search-image?query=professional%20window%20tint%20installation%20luxury%20vehicle%20dark%20premium%20automotive%20shop%20clean%20studio%20precision%20squeegee%20application%20privacy%20film%20sleek%20black&width=700&height=460&seq=svc_full_tint1&orientation=landscape',
    badge: null,
    featured: false,
  },
  {
    id: 'matte',
    icon: 'ri-paint-fill',
    title: 'Matte PPF & Color Change',
    subtitle: 'Satin · Matte · Full Transformation',
    description: 'Transform your gloss paint into a stunning satin or matte finish using premium color-change PPF — while simultaneously protecting the original paint underneath. Fully reversible and available in dozens of finishes.',
    details: [
      'Satin, matte, and semi-gloss finish options',
      'Dozens of premium color choices available',
      'Protects original factory paint underneath',
      'Fully reversible — back to OEM finish any time',
      'Computer-cut for seamless panel-edge installation',
    ],
    image: 'https://readdy.ai/api/search-image?query=matte%20satin%20PPF%20color%20change%20film%20luxury%20sports%20car%20exotic%20vehicle%20dark%20grey%20stealth%20wrap%20premium%20automotive%20photography%20studio%20cinematic%20lighting&width=700&height=460&seq=svc_full_matte1&orientation=landscape',
    badge: null,
    featured: false,
  },
  {
    id: 'windshield',
    icon: 'ri-eye-fill',
    title: 'Windshield Protection Film',
    subtitle: 'Impact Resistance · Optical Clarity',
    description: 'XPEL windshield protection film dramatically reduces the risk of chips and cracks from road debris. Optically clear and anti-reflective, it preserves full visibility while protecting your expensive OEM glass.',
    details: [
      'High-impact resistance from stone chips and gravel',
      'Optical clarity — no distortion or haze',
      'Anti-glare coating available',
      'Easy to replace without full windshield swap',
      'Recommended for highway commuters and sports cars',
    ],
    image: 'https://readdy.ai/api/search-image?query=windshield%20protection%20film%20installation%20luxury%20car%20glass%20front%20windscreen%20clear%20film%20professional%20automotive%20technician%20precision%20application%20shop%20dark%20background&width=700&height=460&seq=svc_full_wind1&orientation=landscape',
    badge: null,
    featured: false,
  },
  {
    id: 'motorcycle',
    icon: 'ri-motorbike-fill',
    title: 'Motorcycle PPF & Ceramic',
    subtitle: 'All Makes & Models · Custom Cut',
    description: 'Custom-cut protection packages designed for motorcycles, exotics, and specialty vehicles. Preserve your bike\'s factory finish from stone chips, road debris, and UV exposure with precision-installed PPF and ceramic coating.',
    details: [
      'Custom-cut patterns for fairings and bodywork',
      'Ceramic coating for engine cases and exhaust',
      'Protection for tank, fenders, and swing arm',
      'Available for all major motorcycle makes',
      'Specialty exotic and collector vehicle packages',
    ],
    image: 'https://readdy.ai/api/search-image?query=premium%20motorcycle%20paint%20protection%20film%20installation%20sport%20bike%20fairing%20ppf%20automotive%20shop%20professional%20custom%20cut%20dark%20studio%20cinematic%20photography%20premium%20detailing&width=700&height=460&seq=svc_full_moto1&orientation=landscape',
    badge: null,
    featured: false,
  },
];

export default function ServicesFull() {
  return (
    <section className="bg-[#080808] py-28" id="services-detail">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-3 inline-flex items-center gap-2">
            <span className="w-6 h-px bg-[#FF6B35]" />
            Full Service Menu
            <span className="w-6 h-px bg-[#FF6B35]" />
          </span>
          <h2 className="font-display font-black text-5xl lg:text-6xl text-white mt-3 mb-5 leading-[1.05]">
            Every Service, <span className="text-[#FF6B35]">Explained</span>
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto leading-relaxed">
            From full vehicle PPF to specialty motorcycle protection — every service is delivered with the same obsessive precision and premium materials.
          </p>
        </div>

        {/* AI Answer Block */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-16">
          {[
            {
              icon: 'ri-shield-star-fill',
              q: 'What services does DBN Garage offer?',
              a: 'DBN Garage offers paint protection film (PPF), ceramic coating, window tint, matte PPF, windshield protection film, and motorcycle PPF and ceramic coating. We serve South Windsor and all of Hartford County, CT. All services are backed by manufacturer warranties and installed by XPEL-certified technicians.',
            },
            {
              icon: 'ri-car-fill',
              q: 'Who is PPF best suited for?',
              a: 'PPF is ideal for new vehicle owners, luxury and exotic car owners, daily drivers exposed to highway conditions, and anyone who wants to preserve resale value. If your vehicle has high miles or frequent highway use, PPF is the single most impactful investment you can make for paint longevity.',
            },
            {
              icon: 'ri-sparkling-2-fill',
              q: 'Can I combine PPF and ceramic coating?',
              a: 'Yes — and many clients do. PPF handles physical protection against chips and scratches. Ceramic coating is applied on top, adding hydrophobic protection, UV resistance, and enhanced gloss. Combined, they deliver complete full-spectrum protection for your vehicle\'s paint and appearance.',
            },
          ].map((item) => (
            <div key={item.q} className="bg-[#111111] border border-white/10 rounded-2xl p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mb-4">
                <i className={`${item.icon} text-[#FF6B35] text-xl`} />
              </div>
              <h3 className="text-white font-bold text-sm mb-2">{item.q}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>

        {/* Service cards */}
        <div className="space-y-6">
          {allServices.map((svc, idx) => (
            <div key={svc.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden border border-white/8 group ${idx % 2 === 0 ? '' : 'lg:flex lg:flex-row-reverse'}`}>
              {/* Image side */}
              <div className="relative overflow-hidden min-h-[280px]">
                <img src={svc.image} alt={svc.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/70 via-transparent to-transparent" />
                {svc.badge && (
                  <span className="absolute top-4 left-4 bg-[#FF6B35] text-white text-xs font-black uppercase tracking-widest px-3 py-1.5 rounded-full">
                    {svc.badge}
                  </span>
                )}
              </div>
              {/* Text side */}
              <div className="bg-[#0E0E0E] p-8 lg:p-10 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-[#FF6B35]/12 rounded-xl">
                    <i className={`${svc.icon} text-[#FF6B35] text-2xl`} />
                  </div>
                  <div>
                    <h3 className="font-display font-black text-xl text-white">{svc.title}</h3>
                    <p className="text-[#FF6B35] text-xs font-semibold uppercase tracking-widest">{svc.subtitle}</p>
                  </div>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed mb-6">{svc.description}</p>
                <ul className="space-y-2.5 mb-8">
                  {svc.details.map((d) => (
                    <li key={d} className="flex items-start gap-2.5">
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-[#FF6B35] text-sm" />
                      </span>
                      <span className="text-gray-300 text-sm leading-snug">{d}</span>
                    </li>
                  ))}
                </ul>
                <Link to="#lead-form"
                  className="self-start inline-flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold text-sm px-6 py-3 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
                  Get a Quote
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Mid CTA */}
        <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#lead-form"
            className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold px-8 py-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-check-fill" /></span>
            Book a Free Consultation
          </a>
          <a href="tel:+18605550127"
            className="flex items-center gap-2 border border-white/20 hover:border-white/50 text-white font-bold px-8 py-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill" /></span>
            Call (860) 555-0127
          </a>
        </div>
      </div>
    </section>
  );
}
